import SignUpPage from "./SignupPage";
export default SignUpPage;